/* VH: vertical filter panel tweaks (dressup-style) — Claude, 2026-10-17 */
(function () {
  var MIN_FOR_SEARCH = 7;
  var busy = false;

  function enhance() {
    if (busy) return;
    var form = document.querySelector('.facets__form-vertical');
    if (!form) return;
    busy = true;
    try {
      var desktop = window.matchMedia('(min-width: 750px)').matches;
      var groups = form.querySelectorAll('details.facets__disclosure-vertical');

      groups.forEach(function (d) {
        /* availability goes to the bottom */
        if (/availability/.test(d.id)) {
          var parent = d.parentNode, last = parent.lastElementChild;
          if (last !== d && last && /facets__disclosure-vertical/.test(last.className)) parent.appendChild(d);
        } else if (desktop && !d.dataset.vhOpened) {
          d.dataset.vhOpened = '1';
          d.setAttribute('open', '');
          var s = d.querySelector('summary');
          if (s) s.setAttribute('aria-expanded', 'true');
        }

        /* search box for long lists (e.g. brands) */
        var list = d.querySelector('ul.facets__list--vertical');
        if (!list || d.querySelector('.vh-facet-search')) return;
        var items = list.querySelectorAll('li.facets__item');
        if (items.length < MIN_FOR_SEARCH) return;

        var box = document.createElement('div');
        box.className = 'vh-facet-search';
        box.innerHTML = '<input type="search" placeholder="ძებნა" aria-label="ძებნა">';
        list.parentNode.insertBefore(box, list);
        var input = box.querySelector('input');
        ['keydown', 'keyup', 'input', 'change'].forEach(function (ev) {
          input.addEventListener(ev, function (e) {
            e.stopPropagation();
            if (ev === 'keydown' && e.key === 'Enter') e.preventDefault();
          });
        });
        input.addEventListener('input', function () {
          var q = input.value.trim().toLowerCase();
          items.forEach(function (li) {
            li.style.display = !q || li.textContent.toLowerCase().indexOf(q) > -1 ? '' : 'none';
          });
        });
      });
    } finally {
      setTimeout(function () { busy = false; }, 0);
    }
  }

  /* ---- price: two boxes + range slider ---- */
  function num(v) { var n = parseFloat(String(v || '').replace(/[\s,]/g, '')); return isNaN(n) ? null : n; }
  function priceSliders() {
    document.querySelectorAll('price-range.facets__price').forEach(function (pr) {
      if (pr.dataset.vhSlider === '1') return;
      var ins = pr.querySelectorAll('input.field__input');
      if (ins.length < 2) return;
      var lo = ins[0], hi = ins[1];
      var max = Math.ceil(num(lo.dataset.max || hi.dataset.max) || 0);
      if (!max) return;
      pr.dataset.vhSlider = '1';
      var wrap = document.createElement('div');
      wrap.className = 'vh-range';
      wrap.innerHTML = '<div class="vh-range__track"><div class="vh-range__fill"></div></div>' +
        '<input type="range" class="vh-range__in" min="0" max="' + max + '" step="1" aria-label="მინიმალური ფასი">' +
        '<input type="range" class="vh-range__in" min="0" max="' + max + '" step="1" aria-label="მაქსიმალური ფასი">';
      var old = pr.parentNode.querySelector('.vh-range');
      if (old) old.remove();
      pr.parentNode.insertBefore(wrap, pr.nextSibling);
      var r1 = wrap.children[1], r2 = wrap.children[2], fill = wrap.querySelector('.vh-range__fill');
      var min = 0;
      function fmt(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' ₾'; }
      function setRange(m) {
        min = Math.max(0, Math.min(m, max - 1));
        r1.min = r2.min = min;
        r1.value = num(lo.value) != null ? Math.max(num(lo.value), min) : min;
        r2.value = num(hi.value) != null ? num(hi.value) : max;
        lo.placeholder = fmt(min);
        hi.placeholder = fmt(max);
        paint();
      }
      function paint() {
        var span = (max - min) || 1, a = +r1.value, b = +r2.value;
        fill.style.left = ((a - min) / span * 100) + '%';
        fill.style.right = (100 - (b - min) / span * 100) + '%';
      }
      function move(e) {
        if (+r1.value > +r2.value - 1) {
          if (e && e.target === r1) r1.value = +r2.value - 1; else r2.value = +r1.value + 1;
        }
        lo.value = +r1.value > min ? r1.value : '';
        hi.value = +r2.value < max ? r2.value : '';
        paint();
      }
      setRange(0);
      minPrice().then(function (m) { if (m != null) setRange(Math.floor(m)); });
      function commit() {
        [lo, hi].forEach(function (i) {
          i.dispatchEvent(new Event('change', { bubbles: true }));
          i.dispatchEvent(new Event('input', { bubbles: true }));
        });
      }
      [r1, r2].forEach(function (r) {
        r.addEventListener('input', function (e) { e.stopPropagation(); move(e); });
        r.addEventListener('change', function (e) { e.stopPropagation(); commit(); });
      });
      [lo, hi].forEach(function (i) {
        i.addEventListener('input', function () {
          var v1 = num(lo.value), v2 = num(hi.value);
          r1.value = v1 != null ? v1 : min; r2.value = v2 != null ? v2 : max; paint();
        });
      });
    });
  }

  /* lowest price in the current collection (cached per tab session) */
  var minPromise = null;
  function minPrice() {
    if (minPromise) return minPromise;
    var m = location.pathname.match(/\/collections\/([^\/?#]+)/);
    if (!m) return (minPromise = Promise.resolve(null));
    var key = 'vhMin:' + m[1];
    try { var c = sessionStorage.getItem(key); if (c) return (minPromise = Promise.resolve(+c)); } catch (e) {}
    var base = '/collections/' + m[1] + '/products.json?limit=250&page=';
    var low = null;
    function page(p) {
      return fetch(base + p).then(function (r) { return r.json(); }).then(function (d) {
        var ps = (d && d.products) || [];
        ps.forEach(function (pr) {
          (pr.variants || []).forEach(function (v) {
            var x = parseFloat(v.price);
            if (!isNaN(x) && x > 0 && (low === null || x < low)) low = x;
          });
        });
        return ps.length === 250 && p < 4 ? page(p + 1) : low;
      });
    }
    minPromise = page(1).then(function (v) {
      try { if (v != null) sessionStorage.setItem(key, v); } catch (e) {}
      return v;
    }).catch(function () { return null; });
    return minPromise;
  }

  /* ---- sort: Georgian labels, short list, custom dropdown on desktop ---- */
  var SORT = [
    ['__rec', 'დალაგება'],
    ['price-ascending', 'ფასი ზრდადობით'],
    ['price-descending', 'ფასი კლებადობით'],
    ['created-descending', 'ბოლოს დამატებული']
  ];
  var REC = ['most-relevant', 'manual'];

  function fixSort() {
    document.querySelectorAll('select[name="sort_by"]').forEach(function (sel) {
      if (sel.dataset.vhSort === '1') return;
      sel.dataset.vhSort = '1';
      var cur = sel.value;
      var have = {};
      Array.prototype.forEach.call(sel.options, function (o) { have[o.value] = true; });
      var recVal = REC.filter(function (v) { return have[v]; })[0] || 'manual';
      if (REC.indexOf(cur) > -1) recVal = cur;
      sel.innerHTML = '';
      SORT.forEach(function (s) {
        var v = s[0] === '__rec' ? recVal : s[0];
        if (!have[v]) return;
        var o = document.createElement('option');
        o.value = v; o.textContent = s[1];
        if (v === cur) o.selected = true;
        sel.appendChild(o);
      });
      if (sel.id === 'SortBy') buildDropdown(sel);
    });
  }

  function buildDropdown(sel) {
    var box = sel.closest('.select');
    if (!box || box.querySelector('.vh-sort')) return;
    box.classList.add('vh-sort-host');
    var w = document.createElement('div');
    w.className = 'vh-sort';
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'vh-sort__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    var list = document.createElement('ul');
    list.className = 'vh-sort__list'; list.setAttribute('role', 'listbox');
    function label() {
      var o = sel.options[sel.selectedIndex];
      btn.innerHTML = '<span>' + (o ? o.textContent : '') + '</span><svg width="12" height="8" viewBox="0 0 10 6"><path fill="currentColor" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708"/></svg>';
      Array.prototype.forEach.call(list.children, function (li) {
        li.classList.toggle('is-active', li.dataset.v === sel.value);
      });
    }
    Array.prototype.forEach.call(sel.options, function (o) {
      if (REC.indexOf(o.value) > -1) return;
      var li = document.createElement('li');
      li.dataset.v = o.value; li.textContent = o.textContent; li.setAttribute('role', 'option');
      li.addEventListener('click', function () {
        w.classList.remove('is-open');
        if (sel.value === o.value) return;
        sel.value = o.value;
        label();
        sel.dispatchEvent(new Event('input', { bubbles: true }));
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      });
      list.appendChild(li);
    });
    btn.addEventListener('click', function (e) { e.stopPropagation(); w.classList.toggle('is-open'); });
    document.addEventListener('click', function (e) { if (!w.contains(e.target)) w.classList.remove('is-open'); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') w.classList.remove('is-open'); });
    w.appendChild(btn); w.appendChild(list);
    box.appendChild(w);
    label();
  }

  function start() {
    fixSort(); priceSliders();
    new MutationObserver(function () { fixSort(); priceSliders(); }).observe(document.body, { childList: true, subtree: true });
    enhance();
    var target = document.querySelector('.facets-vertical') || document.body;
    new MutationObserver(function () { if (!busy) enhance(); }).observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  /* ---- desktop ☰ button → homepage category rows instead of the drawer ---- */
  var DESK = window.matchMedia('(min-width: 990px)');
  var isHome = location.pathname === '/' || location.pathname === '/ka' || location.pathname === '/en';
  function goCats(smooth) {
    var el = document.querySelector('.vh-rows');
    if (!el) return false;
    var hdr = document.querySelector('.section-header, sticky-header');
    var off = (hdr ? hdr.getBoundingClientRect().height : 0) + 12;
    window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - off, behavior: smooth ? 'smooth' : 'auto' });
    return true;
  }
  document.addEventListener('click', function (e) {
    if (!DESK.matches) return;
    var s = e.target.closest && e.target.closest('header-drawer summary');
    if (!s) return;
    e.preventDefault(); e.stopPropagation();
    if (isHome && goCats(true)) return;
    location.href = '/#kategoriebi';
  }, true);
  if (isHome && location.hash === '#kategoriebi') {
    var tries = 0;
    (function wait() {
      if (goCats(false) || ++tries > 40) return;
      setTimeout(wait, 100);
    })();
  }
})();
